import React, { Component, Fragment } from 'react';
import Navigation from '../components/Navigation';
import { translate } from 'react-i18next';

import EditUserTwoFactorAuthenticationForm from '../components/EditUserTwoFactorAuthenticationForm';
import BackupCodeDisplay from '../components/BackupCodeDisplay';
import Remove2FA from '../components/Remove2FA';

import axios from 'axios';
import { Panel, Col, Row, Button } from 'react-bootstrap';
import { FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import config from '../config';
import qs from 'qs';
import { Link } from 'react-router-dom';

import './UserSettings.css';

class UserSettings extends Component {

    constructor(props) {
        super(props);
        this.state = {
            user: this.props.user,
            showCodes: false,
            backupCodes: [],
            hasConfirmedBackupCodes: false,
            isLoading: false,
            token: ''
        };
    }

    componentDidMount() {
        this.loadOrganisationInformation();
    }

    loadOrganisationInformation() {

        var self = this;

        const { uuid } = this.props.match.params;

        axios
            .get(`${config.baseURL}/organisations/${uuid}`, {})
            .then(function(response) {
                self.setState({
                    organisation: response.data.organisation
                });

                self.loadNotificationPropertiesInformation();
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    onRefreshRequired() {
        console.log(`Refresh Required!`);
        this.loadNotificationPropertiesInformation();
    }

    loadNotificationPropertiesInformation() {

        var self = this;
        
        const { uuid } = this.props.match.params;

        axios
            .get(`${config.baseURL}/organisations/${uuid}/notificationpreferences`, {})
            .then(function(response) {
                self.setState({
                    preferences: response.data.preferences[0]
                });
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    handleChange = (e) => {
        this.setState({ [e.target.id]: e.target.value });
    };

    handleBackupCodeConfirmChange = (confirmed) => {
        this.setState({ hasConfirmedBackupCodes: confirmed });
    };

    handleRegenerateCodes = () => {
        this.setState({ isLoading: true, error: '' });

        axios
            .post(`${config.baseURL}/auth/regenerateBackupCodes`, {
                authToken: this.state.token
            })
            .then((response) => {
                this.setState({
                    backupCodes: response.data.backupCodes,
                    hasConfirmedBackupCodes: false,
                    isLoading: false,
                    showCodes: true,
                    token: ''
                });
            })
            .catch((err) => {
                console.error(err);
                this.setState({
                    isLoading: false,
                    error: 'Invalid or expired 2FA token. Please try again.'
                });
            });
    };

    handleFinish = () => {
        this.setState({ showCodes: false });
    };

    render() {
        const { t } = this.props;
        const {
            uuid
        } = this.props.match.params;

        const parsed = qs.parse(this.props.location.search.substring(1));
        const rel = parsed.rel;
        document.title = `MySign Digital Screen Solutions | ${t(
            'UserSettings.title'
        )}`;

        let currentOrganisationUUID = this.props.currentOrganisation.uuid;

        const {
            showCodes,
            backupCodes,
            hasConfirmedBackupCodes,
            isLoading,
            token,
            error
        } = this.state;

        return (
            
            <div className="UserSettings">
                <div id="wrapper">
                    <Navigation props={this.props} />
                    <div id="content-wrapper">
                        <Row>
                            <Col lg={12}>
                                <h1 className="page-header">
                                    {t('UserSettings.title')}
                                    {' - '}
                                    <small>
                                    {this.state.user.firstName}{' '}
                                    {this.state.user.lastName}
                                    </small>
                                </h1>
                                <ol className="breadcrumb">

                                            <li>
                                                <i className="fa fa-tachometer-alt" />{' '}
                                                <Link
                                                    to={`/organisations/${currentOrganisationUUID}`}
                                                >
                                                    {t('Dashboard.title')}
                                                </Link>
                                            </li>
                                            <li className="active">
                                                <i className="fas fa-cog" />{' '}
                                                {t('UserSettings.title')}
                                            </li>{' '}
                                </ol>

                                <Panel id="detail-style">
                                    <Panel.Heading>
                                        <Panel.Title toggle>
                                            {t(
                                                'UserSettings.twoFactorAuthentication'
                                            )}
                                        </Panel.Title>
                                    </Panel.Heading>
                                   
                                    <Panel.Body>
                                        {this.state.user.TwoFAEnabled ? (
                                            <div className="alert alert-success" role="alert">
                                                Two-factor authentication is enabled for this account.
                                            </div>
                                        ) : (
                                            <EditUserTwoFactorAuthenticationForm
                                                user={this.state.user}
                                                userHasAuthenticated={this.props.userHasAuthenticated}
                                                history={this.props.history}
                                            />
                                        )}

                                        {this.state.user.TwoFAEnabled && !showCodes && (
                                            <Fragment>
                                                <div style={{ marginTop: '1.5rem' }}>
                                                    <h4>Regenerate 2FA Backup Codes</h4>
                                                    <FormGroup controlId="token">
                                                        <ControlLabel>Enter your authenticator code</ControlLabel>
                                                        <FormControl
                                                            type="text"
                                                            value={token}
                                                            onChange={this.handleChange}
                                                            placeholder="123456"
                                                        />
                                                    </FormGroup>

                                                    {error && <p className="text-danger">{error}</p>}

                                                    <Button
                                                        bsStyle="warning"
                                                        onClick={this.handleRegenerateCodes}
                                                        disabled={isLoading || token.trim().length === 0}
                                                    >
                                                        {isLoading ? 'Regenerating...' : 'Regenerate Backup Codes'}
                                                    </Button>
                                                </div>

                                                <hr style={{ marginTop: '2rem', marginBottom: '1.5rem' }} />
                                                <div>
                                                    <h4>Disable Two-Factor Authentication</h4>
                                                    <Remove2FA user={this.state.user} />
                                                </div>
                                            </Fragment>
                                        )}

                                        {showCodes && (
                                            <Fragment>
                                                <h4>New Backup Codes</h4>
                                                <BackupCodeDisplay
                                                    backupCodes={backupCodes}
                                                    confirmed={hasConfirmedBackupCodes}
                                                    onConfirmChange={this.handleBackupCodeConfirmChange}
                                                />

                                                <Button
                                                    bsStyle="success"
                                                    className="mt-3"
                                                    disabled={!hasConfirmedBackupCodes}
                                                    onClick={this.handleFinish}
                                                >
                                                    Finish
                                                </Button>
                                            </Fragment>
                                        )}
                                    </Panel.Body>
                                </Panel>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        );
    }
}

export default translate('translations')(UserSettings);
